import { Reveal } from "@components/ui";
import preventionImg1 from "@assets/images/Group-1410087727@2x.png";
import preventionImg2 from "@assets/images/Group-1410087730@2x.png";

const bulletPoints = [
  "Annual Safety Inspection Program for residential and commercial sites.",
  "Leak detection using digital sensors and foam testing.",
  "Replacement of aged valves, regulators, and hoses.",
  "Comprehensive Safety Audit Report issued after each visit.",
];

export function PreventionSection() {
  return (
    <section className="w-full bg-white overflow-hidden px-5 md:px-10 lg:px-[180px] py-12 md:py-16 lg:py-[120px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col-reverse lg:flex-row items-center gap-10 md:gap-14 lg:gap-20 font-albert-sans">
        {/* Illustration */}
        <Reveal direction="left" className="w-full lg:w-[536px] shrink-0">
          <div className="relative w-full max-w-[476px] mx-auto lg:mx-0 aspect-[476/396]">
            <img
              src={preventionImg1}
              alt=""
              className="absolute top-0 left-0 w-[60%] h-auto object-cover"
            />
            <img
              src={preventionImg2}
              alt=""
              className="absolute top-[33%] left-[4%] w-[96%] h-auto object-contain z-[1]"
            />
            <div className="absolute bottom-0 left-[2%] rounded-full bg-[rgba(34,34,34,0.15)] w-[96%] h-[8px] z-[2]" />
          </div>
        </Reveal>

        {/* Text Content */}
        <Reveal direction="right" className="w-full lg:flex-1">
          <div className="flex flex-col items-start gap-8 md:gap-12">
            <div className="flex flex-col items-start gap-5 md:gap-7">
              {/* Pill Badge */}
              <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-[#269d0e]/8 text-[#269d0e] text-[13px] md:text-[15px] font-semibold tracking-[-0.04em] uppercase">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.91 11.12C20.91 16.01 17.36 20.59 12.51 21.93C12.18 22.02 11.82 22.02 11.49 21.93C6.64 20.59 3.09 16.01 3.09 11.12V6.73C3.09 5.91 3.71 4.98 4.48 4.67L10.05 2.39C11.3 1.88 12.71 1.88 13.96 2.39L19.53 4.67C20.29 4.98 20.92 5.91 20.92 6.73L20.91 11.12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9.05 11.87L10.66 13.48L14.96 9.18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Prevention
              </span>
              <h2 className="text-[28px] md:text-[44px] lg:text-[60px] font-semibold tracking-[-0.04em] text-[#122d63] leading-[1.1] max-w-[685px]">
                Prevent Incidents Before They Happen
              </h2>
              <div className="flex flex-col items-start gap-2 md:gap-[9px]">
                <p className="text-[14px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-[#62636c] leading-[32px]">
                  In addition to standard supply services, we also offer
                  tailored gas solutions for developers, property managers, and
                  large infrastructure projects.
                </p>
                <div className="flex flex-col gap-4 md:gap-5">
                  {bulletPoints.map((point, index) => (
                    <div
                      key={index}
                      className="group/item flex items-start gap-3 p-2 -ml-2 rounded-[10px] hover:bg-[#269d0e]/[0.04] transition-colors duration-200"
                    >
                      {/* Green Checkmark in Tinted Circle */}
                      <div className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-[#269d0e]/10 flex items-center justify-center shrink-0 mt-0.5 transition-transform duration-200 group-hover/item:scale-110">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.5 8.5L6.5 11.5L12.5 4.5" stroke="#269d0e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                      <p className="text-[14px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-[#62636c] leading-[32px]">
                        {point}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <button className="flex items-center justify-center gap-2.5 py-3 pl-5 pr-3 bg-[#090d2c] rounded-[40px] hover:bg-[#3d405e] transition-colors group">
              <span className="text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-white">
                Book a Maintenance Visit
              </span>
              {/* Inline SVG Arrow */}
              <span className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/20 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.43 5.93L20.5 12L14.43 18.07" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3.5 12H20.33" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
